"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = exports.getMessage = void 0;
var _reactIntl = require("react-intl");
var messages = exports.messages = {
  QuintoAndar: (0, _reactIntl.defineMessages)({
    altSymbol: {
      id: 'components.Logo.QuintoAndar.symbol.alt',
      defaultMessage: 'Símbolo do QuintoAndar'
    },
    altWordmark: {
      id: 'components.Logo.QuintoAndar.wordmark.alt',
      defaultMessage: 'Wordmark do QuintoAndar'
    },
    altComplete: {
      id: 'components.Logo.QuintoAndar.complete.alt',
      defaultMessage: 'Logo do QuintoAndar'
    }
  }),
  inmuebles24: (0, _reactIntl.defineMessages)({
    altSymbol: {
      id: 'components.Logo.inmuebles24.symbol.alt',
      defaultMessage: 'Símbolo de Inmuebles24'
    },
    altWordmark: {
      id: 'components.Logo.inmuebles24.wordmark.alt',
      defaultMessage: 'Marca denominativa de Inmuebles24'
    },
    altComplete: {
      id: 'components.Logo.inmuebles24.complete.alt',
      defaultMessage: 'Logotipo de Inmuebles24'
    }
  })
};
var getMessage = exports.getMessage = function getMessage(product) {
  return messages[product];
};